import { jsx as y, Fragment as q, jsxs as De } from "react/jsx-runtime";
import { createContext as ue, useState as ke, useContext as S, useMemo as v, useRef as Me, useEffect as je, useId as Ae } from "react";
import n, { z as c } from "zod";
import { JsonLd as k } from "react-schemaorg";
import { useEffectOnce as Ie } from "@made-people/react-use-effect-once";
import { isProductMediaImage as Fe } from "@made-people/grease-product";
const Ce = n.object({
  "@type": n.literal("BreadcrumbList"),
  itemListElement: n.array(
    n.object({
      "@type": n.literal("ListItem"),
      position: n.number(),
      item: n.object({
        name: n.string(),
        "@id": n.string()
      })
    })
  )
}), xe = Ce;
function Le(e) {
  const t = xe.safeParse(e);
  return t.success, t.success;
}
var D = /* @__PURE__ */ ((e) => (e.FAQPage = "FAQPage", e.Product = "Product", e.ProductList = "ProductList", e.MerchantReturnPolicy = "MerchantReturnPolicy", e.ShippingRateSettings = "ShippingRateSettings", e))(D || {});
const Ue = {
  structuredDataScripts: {},
  addToScripts: () => {
  },
  removeFromScripts: () => {
  }
}, N = ue(Ue), Ne = ({
  children: e
}) => {
  const [t, i] = ke({}), s = (u, o) => {
    u in t && typeof t[u] < "u" && console.info(
      "Structured data script already exists, overwriting it...",
      u
    ), i({ ...t, [u]: o });
  }, a = (u) => {
    if (!(u in t))
      return;
    const { [u]: o, ...r } = t;
    i(r);
  };
  return /* @__PURE__ */ y(
    N.Provider,
    {
      value: {
        structuredDataScripts: t,
        addToScripts: s,
        removeFromScripts: a
      },
      children: e
    }
  );
}, Ve = () => {
  const { structuredDataScripts: e } = S(N);
  return e;
}, Ee = () => {
  const { addToScripts: e } = S(N);
  return e;
}, Qt = () => {
  const { removeFromScripts: e } = S(N);
  return e;
}, w = ue(void 0), $t = (e) => {
  const t = {
    mappers: e.mappers,
    pdpProduct: e.pdpProduct,
    context: e.context,
    offerShippingDetailsSettings: e.offerShippingDetailsSettings,
    merchantReturnPolicySettings: e.merchantReturnPolicySettings,
    breadCrumbs: e.breadCrumbs
  };
  return /* @__PURE__ */ y(w.Provider, { value: t, children: /* @__PURE__ */ y(Ne, { children: e.children }) });
}, zt = () => {
  const e = S(w);
  if (e === void 0)
    throw new Error(
      "useStructuredDataMappers must be used within a StructuredDataProvider"
    );
  return e.mappers;
}, Qe = () => {
  const e = S(w);
  if (e === void 0)
    throw new Error(
      "usePdpProduct must be used within a StructuredDataProvider"
    );
  return e.pdpProduct;
}, R = () => {
  const e = S(w);
  if (e === void 0)
    throw new Error(
      "useStructuredDataContext must be used within a StructuredDataProvider"
    );
  return e.context;
}, $e = () => {
  const e = S(w);
  if (e === void 0)
    throw new Error(
      "useShippingDetailsSettings must be used within a StructuredDataProvider"
    );
  return e.offerShippingDetailsSettings;
}, ze = () => {
  const e = S(w);
  if (e === void 0)
    throw new Error(
      "useBreadCrumbs must be used within a StructuredDataProvider"
    );
  return e.breadCrumbs;
}, qe = () => {
  const e = S(w);
  if (e === void 0)
    throw new Error(
      "useMerchantReturnPolicySettings must be used within a StructuredDataProvider"
    );
  return e.merchantReturnPolicySettings;
}, Be = () => {
  const e = ze(), { baseUrl: t, siteSlug: i } = R(), s = v(() => {
    if (typeof e > "u" || typeof t > "u" || typeof i > "u")
      return;
    const a = {
      "@type": "BreadcrumbList",
      itemListElement: e.map((u, o) => {
        const r = u.slug === "" ? u.slug : `/${u.slug}`;
        return {
          "@type": "ListItem",
          position: o,
          item: {
            name: u.label,
            "@id": `${t}/${i}${r}`
          }
        };
      })
    };
    if (Le(a))
      return a;
  }, [e, t]);
  return typeof s > "u" ? null : /* @__PURE__ */ y(
    k,
    {
      item: {
        "@context": "https://schema.org",
        ...s
      }
    }
  );
}, We = n.enum([
  "BackOrder",
  "Discontinued",
  "InStock",
  "InStoreOnly",
  "LimitedAvailability",
  "OnlineOnly",
  "OutOfStock",
  "PreOrder",
  "PreSale",
  "SoldOut"
]), B = We;
function qt(e) {
  const t = B.safeParse(e);
  return t.success, t.success;
}
const He = n.object({
  "@type": n.literal("MonetaryAmount"),
  value: n.number().optional(),
  minValue: n.number().optional(),
  maxValue: n.number().optional(),
  currency: n.string()
}).refine(
  ({ maxValue: e, minValue: t, value: i }) => typeof e > "u" && typeof t > "u" && typeof i == "number" || typeof e == "number" && typeof t == "number" && typeof i > "u",
  {
    message: "Either both `minValue` and `maxValue` or only `value` have to be defined"
  }
), L = He;
function ce(e) {
  const t = L.safeParse(e);
  return t.success, t.success;
}
const Ge = n.object({
  "@type": n.literal("DefinedRegion"),
  addressCountry: n.string().nonempty(),
  addressRegion: n.string().nonempty().optional()
}), W = Ge;
function _e(e) {
  const t = W.safeParse(e);
  return t.success, t.success;
}
const Ke = n.object({
  "@type": n.literal("QuantitativeValue"),
  minValue: n.number(),
  maxValue: n.number(),
  unitCode: n.string()
}).transform((e, t) => {
  switch (e.unitCode) {
    case "min":
    case "minutes": {
      e.unitCode = "min";
      break;
    }
    case "h":
    case "hours": {
      e.unitCode = "h";
      break;
    }
    case "days":
    case "d": {
      e.unitCode = "d";
      break;
    }
    case "wk":
    case "weeks": {
      e.unitCode = "wk";
      break;
    }
    default: {
      t.addIssue({
        fatal: !0,
        path: t.path,
        code: "invalid_enum_value",
        received: e.unitCode,
        options: ["minutes", "hours", "d", "weeks"]
      });
      break;
    }
  }
  return e;
}), U = Ke;
function Bt(e) {
  const t = U.safeParse(e);
  return t.success, t.success;
}
function re(e) {
  const t = U.safeParse(e);
  if (t.success)
    return t.data;
}
const Je = n.enum([
  "Monday",
  "https://schema.org/Monday",
  "Tuesday",
  "https://schema.org/Tuesday",
  "Wednesday",
  "https://schema.org/Wednesday",
  "Thursday",
  "https://schema.org/Thursday",
  "Friday",
  "https://schema.org/Friday",
  "Saturday",
  "https://schema.org/Saturday",
  "Sunday",
  "https://schema.org/Sunday"
]), fe = Je;
function Wt(e) {
  const t = fe.safeParse(e);
  return t.success, t.success;
}
const Xe = n.object({
  "@type": n.literal("ShippingDeliveryTime"),
  cutoffTime: n.string().nonempty().optional(),
  handlingTime: U.optional(),
  transitTime: U.optional(),
  businessDays: n.object({
    "@type": n.literal("OpeningHoursSpecification"),
    dayOfWeek: fe.array()
  })
}), de = Xe;
function Ye(e) {
  const t = de.safeParse(e);
  return t.success, t.success;
}
const Ze = n.object({
  "@type": n.literal("OfferShippingDetails"),
  shippingSettingsLink: n.string(),
  deliveryTime: de.optional(),
  shippingRate: L,
  shippingDestination: W
}), pe = Ze;
function et(e) {
  const t = pe.safeParse(e);
  return t.success, t.success;
}
const tt = n.object({
  "@type": n.literal("Offer"),
  price: n.number(),
  name: n.string().optional(),
  priceCurrency: n.string(),
  availability: B,
  shippingDetails: pe.optional()
}), H = tt;
function Ht(e) {
  const t = H.safeParse(e);
  return t.success, t.success;
}
const nt = n.object({
  "@type": n.literal("ProductModel"),
  sku: n.string().nonempty(),
  name: n.string().nonempty(),
  mpn: n.string().nonempty().optional(),
  size: n.string().nonempty().optional(),
  image: n.string().array().nonempty().optional(),
  color: n.string().nonempty().optional(),
  offers: H,
  url: n.string()
}).refine(
  (e) => !(typeof e.size > "u" && typeof e.color > "u"),
  {
    message: "Both `size` and `color` cannot be undefined simultaneously on a product model"
  }
), G = nt;
function Gt(e) {
  return G.safeParse(e).success;
}
function it(e) {
  if (typeof e > "u")
    return;
  const t = G.safeParse(e);
  if (t.success)
    return t.data;
}
const rt = n.object({
  "@type": n.literal("AggregateOffer"),
  lowPrice: n.number(),
  highPrice: n.number(),
  name: n.string().optional(),
  priceCurrency: n.string(),
  availability: B
}), le = rt;
function _t(e) {
  const t = le.safeParse(e);
  return t.success, t.success;
}
const st = n.object({
  "@type": n.literal("AggregateRating"),
  ratingValue: n.union([n.number(), n.string()]),
  bestRating: n.union([n.number(), n.string()]).optional(),
  worstRating: n.union([n.number(), n.string()]).optional(),
  ratingCount: n.number().int().positive().optional(),
  reviewCount: n.number().int().positive().optional()
}), _ = st;
function Kt(e) {
  return _.safeParse(e).success;
}
function Jt(e) {
  const t = _.safeParse(e);
  if (t.success)
    return t.data;
}
const ot = n.object({
  "@type": n.literal("Rating"),
  ratingValue: n.union([n.number(), n.string()]),
  bestRating: n.union([n.number(), n.string()]).optional(),
  worstRating: n.union([n.number(), n.string()]).optional(),
  author: n.union([
    n.object({
      "@type": n.literal("Person"),
      name: n.string()
    }),
    n.object({
      "@type": n.literal("Organization"),
      name: n.string()
    })
  ]).optional()
}), K = ot;
function Xt(e) {
  return K.safeParse(e).success;
}
function Yt(e) {
  const t = K.safeParse(e);
  if (t.success)
    return t.data;
}
const at = n.object({
  "@type": n.literal("Review"),
  reviewBody: n.string().optional(),
  reviewRating: K.optional(),
  author: n.union([
    n.object({
      "@type": n.literal("Person"),
      name: n.string()
    }),
    n.object({
      "@type": n.literal("Organization"),
      name: n.string()
    })
  ]).optional(),
  datePublished: n.string().optional(),
  name: n.string().optional(),
  description: n.string().optional(),
  reviewAspect: n.string().optional(),
  positiveNotes: n.string().optional(),
  negativeNotes: n.string().optional()
}), J = at;
function Zt(e) {
  return J.safeParse(e).success;
}
function en(e) {
  const t = J.safeParse(e);
  if (t.success)
    return t.data;
}
const ut = n.object({
  "@type": n.literal("MerchantReturnPolicy"),
  applicableCountry: n.string().optional(),
  returnPolicyCategory: n.enum([
    "MerchantReturnFiniteReturnWindow",
    "MerchantReturnNotPermitted",
    "MerchantReturnUnlimitedWindow",
    "MerchantReturnUnspecified"
  ]).optional(),
  merchantReturnDays: n.number().min(0).optional(),
  returnMethod: n.enum(["ReturnAtKiosk", "ReturnByMail", "ReturnInStore"]).optional(),
  returnFees: n.enum([
    "FreeReturn",
    "ReturnFeesCustomerResponsibility",
    "ReturnShippingFees"
  ]).optional(),
  inStoreReturnsOffered: n.boolean().optional()
}), ge = ut;
function tn(e) {
  const t = ge.safeParse(e);
  return t.success, t.success;
}
const ct = n.object({
  "@type": n.literal("Product"),
  sku: n.string().nonempty(),
  name: n.string().nonempty(),
  description: n.string().nonempty().optional(),
  image: n.string().array().nonempty().optional(),
  offers: H.or(le),
  model: n.array(G).nonempty().optional(),
  url: n.string(),
  aggregateRating: _.optional(),
  review: n.array(J).optional(),
  hasMerchantReturnPolicy: ge.optional()
}).refine(
  (e) => {
    var t;
    return !(typeof e.model < "u" && ((t = e.offers) == null ? void 0 : t["@type"]) === "Offer");
  },
  {
    message: "If `model` is defined, `offers` need to be of type 'AggregateOffer'"
  }
).refine(
  (e) => {
    var t;
    return !(typeof e.model > "u" && ((t = e.offers) == null ? void 0 : t["@type"]) === "AggregateOffer");
  },
  {
    message: "If `model` is undefined, `offers` need to be of type 'Offer'"
  }
).refine(
  (e) => !(typeof e.model > "u" && typeof e.offers > "u"),
  { message: "Both `model` and `offers` cannot be undefined simultaneously" }
), X = ct;
function ft(e) {
  return X.safeParse(e).success;
}
function dt(e) {
  const t = X.safeParse(e);
  if (t.success)
    return t.data;
}
const pt = n.object({
  "@type": n.literal("ItemList"),
  itemListElement: n.array(
    n.object({
      "@type": n.literal("ListItem"),
      position: n.number(),
      item: X
    })
  )
}), me = pt;
function lt(e) {
  return me.safeParse(e).success;
}
function nn(e) {
  const t = me.safeParse(e);
  if (t.success)
    return t.data;
}
const ye = c.object({
  applicableCountry: c.string().optional(),
  returnPolicyCategory: c.enum([
    "MerchantReturnFiniteReturnWindow",
    "MerchantReturnNotPermitted",
    "MerchantReturnUnlimitedWindow",
    "MerchantReturnUnspecified"
  ]).optional(),
  merchantReturnDays: c.number().min(0).optional(),
  returnMethod: c.enum(["ReturnAtKiosk", "ReturnByMail", "ReturnInStore"]).optional(),
  returnFees: c.enum([
    "FreeReturn",
    "ReturnFeesCustomerResponsibility",
    "ReturnShippingFees"
  ]).optional(),
  inStoreReturnsOffered: c.boolean().optional()
});
function rn(e) {
  return ye.safeParse(e).success;
}
const he = ye.array().nonempty();
function gt(e) {
  return he.safeParse(e).success;
}
function sn(e, t) {
  const i = he.safeParse(e);
  if (!i.success) {
    t == null || t(i.error);
    return;
  }
  return i.data;
}
const mt = (e) => {
  const { country: t, baseUrl: i } = R();
  return v(() => {
    var a, u, o, r, f, p;
    return gt(e) ? {
      "@type": "MerchantReturnPolicy",
      applicableCountry: ((a = e == null ? void 0 : e[0]) == null ? void 0 : a.applicableCountry) || t,
      returnPolicyCategory: (u = e == null ? void 0 : e[0]) == null ? void 0 : u.returnPolicyCategory,
      merchantReturnDays: (o = e == null ? void 0 : e[0]) == null ? void 0 : o.merchantReturnDays,
      returnMethod: (r = e == null ? void 0 : e[0]) == null ? void 0 : r.returnMethod,
      returnFees: (f = e == null ? void 0 : e[0]) == null ? void 0 : f.returnFees,
      inStoreReturnsOffered: (p = e == null ? void 0 : e[0]) == null ? void 0 : p.inStoreReturnsOffered
    } : void 0;
  }, [e, t, i]);
}, se = c.object({
  unit: c.enum(["days", "hours", "minutes", "seconds"]),
  endTime: c.number(),
  startTime: c.number(),
  isEnabled: c.boolean()
}), be = c.object({
  cutoffTime: c.string().optional(),
  handlingTime: se,
  transitTime: se
});
function on(e) {
  const t = be.safeParse(e);
  return t.success || console.warn(
    "Failed to parse type shippingDeliveryTimeSettingSchema: ",
    t.error
  ), t.success;
}
const Se = c.object({
  countries: c.string().array().nonempty(),
  deliveryTime: be.array().min(1).max(1).optional(),
  region: c.string().optional(),
  shippingRateMin: c.string(),
  shippingRateMax: c.string(),
  freeShippingThreshold: c.string().optional(),
  shippingSettingsLink: c.object({
    href: c.string()
  }).optional()
});
function an(e) {
  return Se.safeParse(e).success;
}
const ve = Se.array().nonempty();
function M(e) {
  return ve.safeParse(e).success;
}
function un(e, t) {
  const i = ve.safeParse(e);
  if (!i.success) {
    t == null || t(i.error);
    return;
  }
  return i.data;
}
const yt = (e) => {
  const { country: t, currencyCode: i } = R();
  return v(() => {
    if (!M(e))
      return;
    const s = /* @__PURE__ */ new Map();
    for (const a of e) {
      if (!a.countries.includes(t))
        continue;
      const u = a.countries.join("");
      if (s.has(u)) {
        console.warn(`Duplicate key ${u} in StructuredDataShippingRate`);
        continue;
      }
      let o = parseInt(
        a.shippingRateMin
      );
      isNaN(o) && (o = void 0);
      let r = parseInt(
        a.shippingRateMax
      );
      isNaN(r) && (r = void 0);
      let f;
      typeof o == "number" && typeof r == "number" && (f = {
        "@type": "MonetaryAmount",
        minValue: o,
        maxValue: r,
        currency: i
      }), ce(f) && s.set(u, f);
    }
    if (s.size !== 0)
      return s;
  }, [e, t, i]);
}, ht = (e) => {
  const { country: t } = R();
  return v(() => {
    if (!M(e))
      return;
    const i = /* @__PURE__ */ new Map();
    for (const s of e) {
      if (!s.countries.includes(t))
        continue;
      const a = s.countries.join("");
      if (i.has(a)) {
        console.warn(`Duplicate key ${a} in StructuredDataShippingRate`);
        continue;
      }
      const u = {
        "@type": "DefinedRegion",
        addressCountry: t
      };
      typeof s.region == "string" && s.region.length > 0 && (u.addressRegion = s.region), _e(u) && i.set(a, u);
    }
    if (i.size !== 0)
      return i;
  }, [e, t]);
}, bt = (e) => {
  const { country: t } = R();
  return v(() => {
    var s;
    if (!M(e))
      return;
    const i = /* @__PURE__ */ new Map();
    for (const a of e) {
      if (!a.countries.includes(t))
        continue;
      const u = a.countries.join("");
      if (i.has(u)) {
        console.warn(`Duplicate key ${u} in StructuredDataShippingRate`);
        continue;
      }
      if (typeof a > "u" || !Array.isArray(a.deliveryTime) || typeof a.deliveryTime[0] > "u")
        continue;
      const [o] = a.deliveryTime, r = {
        "@type": "ShippingDeliveryTime",
        businessDays: {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: [
            "https://schema.org/Monday",
            "https://schema.org/Tuesday",
            "https://schema.org/Wednesday",
            "https://schema.org/Thursday",
            "https://schema.org/Friday"
          ]
        }
      };
      if (o.handlingTime.isEnabled === !0 && (r.handlingTime = {
        "@type": "QuantitativeValue",
        minValue: o.handlingTime.startTime,
        maxValue: o.handlingTime.endTime,
        unitCode: o.handlingTime.unit
      }, r.handlingTime = re(r.handlingTime)), o.transitTime.isEnabled === !0 && (r.transitTime = {
        "@type": "QuantitativeValue",
        minValue: o.transitTime.startTime,
        maxValue: o.transitTime.endTime,
        unitCode: o.transitTime.unit
      }, r.transitTime = re(r.transitTime)), typeof o.cutoffTime == "string" && /(([0-1][0-9])|(2[0-3])):[0-5][0-9]/.test(o.cutoffTime)) {
        const [f, p] = o.cutoffTime.split(
          ":"
        );
        let m = parseInt(f);
        (isNaN(m) || m > 23 || m < 0) && (m = void 0);
        let l = parseInt(p);
        if ((isNaN(l) || l > 59 || l < 0) && (l = void 0), typeof m < "u") {
          const g = /* @__PURE__ */ new Date();
          g.setUTCHours(m, l ?? 0, 0, 0), r.cutoffTime = (s = g.toJSON().split("T")) == null ? void 0 : s[1];
        }
      }
      Object.values(r ?? {}).filter((f) => typeof f < "u").length < 1 || Ye(r) && i.set(u, r);
    }
    if (i.size !== 0)
      return i;
  }, [e, t]);
}, Y = (e) => {
  const t = yt(
    e
  ), i = ht(
    e
  ), s = bt(
    e
  ), { country: a, baseUrl: u } = R();
  return v(() => {
    if (!M(e) || typeof i > "u" || typeof t > "u" || typeof s > "u")
      return;
    const o = /* @__PURE__ */ new Map();
    for (const r of e) {
      if (!r.countries.includes(a))
        continue;
      const f = r.countries.join("");
      if (o.has(f)) {
        console.warn(`Duplicate key ${f} in OfferShippingDetails`);
        continue;
      }
      const p = t.get(f), m = i.get(f), l = s.get(f);
      if (typeof p > "u" || typeof m > "u" || typeof l > "u")
        return;
      const g = r == null ? void 0 : r.shippingSettingsLink, h = {
        "@type": "OfferShippingDetails",
        shippingDestination: m,
        deliveryTime: l,
        // @ts-expect-error - setting shippingRate to undefined is intentional
        shippingRate: void 0
      };
      g && (h.shippingSettingsLink = `${u}${g.href}`), ce(p) && (h.shippingRate = p), et(h) && o.set(f, h);
    }
    if (o.size !== 0)
      return o;
  }, [
    e,
    t,
    i,
    s,
    a,
    u
  ]);
};
function oe(e) {
  if (typeof e != "string")
    return !1;
  try {
    new URL(e);
  } catch {
    return !1;
  }
  return !0;
}
function ae(e, t, i, s, a = !0, u, o) {
  var ee, te, I, ne;
  const r = {
    "@type": "Product",
    name: e.name
  }, f = e.sku, p = e.name, m = e.description, l = e.countryOfOrigin, g = e.priceAsNumber, h = e.brandName, j = (ee = e.imageUrls) == null ? void 0 : ee.filter((d) => oe(d)), V = e.urlSlug;
  if (typeof f > "u") {
    console.warn(
      `[useStructuredDataProduct]: Invalid sku for product, got ${f}. Product object: `,
      e
    );
    return;
  }
  let O = 1 / 0, A = 0;
  for (let d = 0; d < e.variants.length; ++d) {
    const b = e.variants[d];
    if (typeof b > "u")
      continue;
    const P = {
      "@type": "ProductModel"
    }, F = b.sku, Q = b.size, $ = b.ean, C = b.priceAsNumber ?? g;
    let x = (te = b.imageUrls) == null ? void 0 : te.filter((Te) => oe(Te));
    if (typeof x > "u" && (x = j), typeof F == "string" && F.length > 0)
      P.sku = F;
    else {
      console.warn(
        `[useStructuredDataProduct]: Invalid sku for variant, got ${F}. Variant object: `,
        b
      );
      continue;
    }
    typeof p == "string" && p.length > 0 && (P.name = p), typeof Q == "string" && Q.length > 0 && (P.size = Q), typeof $ == "string" && $.length > 0 && (P.mpn = $), c.string().nonempty().array().nonempty().safeParse(x).success && (P.image = x), typeof t == "string" && t.length > 0 && typeof C == "number" && typeof b.quantity == "number" && (P.offers = {
      "@type": "Offer",
      price: C,
      priceCurrency: t,
      availability: b.quantity > 0 ? "InStock" : "OutOfStock",
      ...o && { shippingDetails: o }
    }, O = Math.min(O, C), A = Math.max(O, C));
    const z = b.urlSlug ?? e.urlSlug;
    typeof i == "string" && i.length > 0 && typeof z == "string" && z.length > 0 && (P.url = `${i}/${s}/${z}`);
    const ie = it(P);
    typeof ie > "u" || (r.model = [
      ie,
      ...r.model ?? []
    ]);
  }
  typeof h == "string" && h.length > 0 && (r.brand = {
    "@type": "Brand",
    name: h
  }), typeof f == "string" && f.length > 0 && (r.sku = f), typeof p == "string" && p.length > 0 && (r.name = p), typeof m == "string" && m.length > 0 && (r.description = m), typeof t == "string" && t.length > 0 && typeof r.model < "u" && (typeof g == "number" || typeof O == "number" && typeof A == "number") ? r.offers = {
    "@type": "AggregateOffer",
    lowPrice: typeof O == "number" ? O : g,
    highPrice: typeof A == "number" ? A : g,
    priceCurrency: t,
    availability: r.model.some(
      (d) => d.offers.availability === "InStock"
    ) ? "InStock" : "OutOfStock"
  } : typeof r.model > "u" && typeof t == "string" && t.length > 0 && typeof g == "number" && (r.offers = {
    "@type": "Offer",
    price: g,
    priceCurrency: t,
    availability: (ne = (I = e.variants) == null ? void 0 : I.some) != null && ne.call(
      I,
      (d) => typeof (d == null ? void 0 : d.quantity) == "number" && (d == null ? void 0 : d.quantity) > 0
    ) ? "InStock" : "OutOfStock",
    ...o && { shippingDetails: o }
  }), typeof i == "string" && i.length > 0 && typeof V == "string" && V.length > 0 && (r.url = `${i}/${s}/${V}`), typeof j < "u" && c.string().array().nonempty().safeParse(j).success && (r.image = j), typeof l == "string" && l.length > 0 && (r.countryOfOrigin = {
    "@type": "Country",
    name: l
  });
  const T = a ? e.aggregateRating : void 0, E = a ? e.reviews : void 0;
  return T && (r.aggregateRating = {
    "@type": "AggregateRating",
    ratingValue: T.ratingValue,
    bestRating: T.bestRating,
    worstRating: T.worstRating,
    reviewCount: T.reviewCount,
    ratingCount: T.ratingCount
  }), E && E.length > 0 && (r.review = E.map((d) => ({
    "@type": "Review",
    reviewBody: d.reviewBody,
    reviewRating: d.reviewRating ? {
      "@type": "Rating",
      ratingValue: d.reviewRating.ratingValue,
      bestRating: d.reviewRating.bestRating,
      worstRating: d.reviewRating.worstRating
    } : void 0,
    author: d.author ? {
      "@type": d.author.type,
      name: d.author.name
    } : void 0,
    datePublished: d.datePublished,
    name: d.name,
    description: d.description,
    reviewAspect: d.reviewAspect,
    positiveNotes: d.positiveNotes,
    negativeNotes: d.negativeNotes
  }))), u && (r.hasMerchantReturnPolicy = u), dt(r);
}
function Pe(e) {
  const { currencyCode: t, baseUrl: i, siteSlug: s, country: a } = R(), u = qe(), o = $e(), r = mt(
    u
  ), f = Y(
    o
  ), p = a, m = f == null ? void 0 : f.get(p);
  return v(() => {
    if (!(typeof e > "u" || typeof t > "u" || typeof i > "u" || typeof s > "u"))
      if (Array.isArray(e)) {
        if (e.length === 0)
          return;
        const l = {
          "@type": "ItemList",
          itemListElement: []
        };
        for (let g = 0; g < e.length; ++g) {
          const h = e[g];
          typeof h > "u" || l.itemListElement.push({
            "@type": "ListItem",
            position: g + 1,
            item: ae(
              h,
              t,
              i,
              s,
              !1,
              // Don't include reviews for product lists
              r,
              m
            )
          });
        }
        return lt(l) ? l : void 0;
      } else
        return ae(
          e,
          t,
          i,
          s,
          !0,
          // Include reviews for single product (PDP)
          r,
          m
        );
  }, [
    e,
    t,
    i,
    s,
    r,
    m
  ]);
}
const St = ({
  unformattedProducts: e
}) => {
  const t = Pe(e), i = Me(0);
  return je(() => {
    i.current += 1;
  }, [t]), typeof t > "u" ? null : /* @__PURE__ */ y(
    k,
    {
      item: {
        "@context": "https://schema.org",
        ...t
      }
    },
    i.current
  );
}, vt = ({ settings: e }) => {
  const t = Y(e);
  return /* @__PURE__ */ y(q, { children: [...(t == null ? void 0 : t.entries()) ?? []].map(
    ([i, s]) => /* @__PURE__ */ y(
      k,
      {
        item: {
          "@context": "https://schema.org",
          ...s
        }
      },
      i
    )
  ) });
}, Pt = n.object({
  "@type": n.literal("ShippingRateSettings"),
  shippingRate: L,
  freeShippingThreshold: L,
  shippingDestination: W
}), Re = Pt;
function Rt(e) {
  const t = Re.safeParse(e);
  return t.success, t.success;
}
function cn(e) {
  const t = Re.safeParse(e);
  if (t.success)
    return t.data;
}
const wt = ({ settings: e }) => {
  const { country: t, currencyCode: i, currentPath: s } = R(), a = Y(e), u = v(() => {
    var r;
    if (!M(e) || typeof a > "u")
      return;
    const o = /* @__PURE__ */ new Map();
    for (const f of e) {
      if (!f.countries.includes(t))
        continue;
      const p = f.countries.join(""), m = a.get(p);
      if (typeof m > "u" || ((r = f.shippingSettingsLink) == null ? void 0 : r.href) !== s)
        continue;
      const l = {
        ...m,
        "@type": "ShippingRateSettings"
      };
      if (delete l.deliveryTime, delete l.shippingSettingsLink, typeof f.freeShippingThreshold == "string") {
        let g = parseFloat(
          f.freeShippingThreshold
        );
        isNaN(g) && (g = void 0), typeof g < "u" && (l.freeShippingThreshold = {
          "@type": "MonetaryAmount",
          value: g,
          currency: i
        });
      }
      if (o.has(p)) {
        console.warn(`Duplicate key ${p} in ShippingRateSettings`);
        continue;
      }
      Rt(l) && o.set(p, l);
    }
    if (o.size !== 0)
      return o;
  }, [a, e]);
  return /* @__PURE__ */ y(q, { children: [...(u == null ? void 0 : u.entries()) ?? []].map(
    ([o, r]) => /* @__PURE__ */ y(
      k,
      {
        item: {
          "@context": "https://schema.org",
          ...r
        }
      },
      o
    )
  ) });
}, fn = ({
  offerShippingDetailsSettings: e
}) => {
  const t = Qe(), i = Ve();
  return /* @__PURE__ */ De(q, { children: [
    Object.entries(i).filter(([s]) => !(typeof t < "u" && s === D.ProductList)).map(([, s]) => s),
    /* @__PURE__ */ y(Be, {}),
    /* @__PURE__ */ y(vt, { settings: e }),
    /* @__PURE__ */ y(
      wt,
      {
        settings: e
      }
    ),
    /* @__PURE__ */ y(St, { unformattedProducts: t })
  ] });
}, Ot = n.object({
  "@type": n.literal("FAQPage"),
  mainEntity: n.array(
    n.object({
      "@type": n.literal("Question"),
      name: n.string(),
      acceptedAnswer: n.object({
        "@type": n.literal("Answer"),
        text: n.string()
      })
    })
  ).nonempty()
}), Tt = Ot;
function Dt(e) {
  const t = Tt.safeParse(e);
  return t.success, t.success;
}
const we = (e, t) => {
  const i = Ee(), s = Ae();
  Ie(
    () => {
      if (typeof e > "u")
        return;
      const a = `schema-org-script-${e.name ?? e["@type"] ?? t}-${s}`, u = /* @__PURE__ */ y(
        k,
        {
          item: {
            "@context": "https://schema.org",
            ...e
          }
        },
        a
      );
      i(t, u);
    },
    {
      ifDefined: [e]
    }
  );
}, kt = (e) => {
  if (e.length === 0)
    return;
  const t = {
    "@type": "FAQPage"
  };
  let i = [];
  for (const { q: s, a } of e) {
    if (typeof s != "string" || typeof a != "string") {
      console.warn("[useInjectFAQPage]: Wrong input, got", { q: s, a });
      continue;
    }
    i = [
      ...i,
      {
        "@type": "Question",
        name: s,
        acceptedAnswer: {
          "@type": "Answer",
          text: a
        }
      }
    ];
  }
  if (t.mainEntity = i, !Dt(t)) {
    console.warn(
      "[useInjectFAQPage]: Could not generate FAQ Page structured data from: ",
      e,
      " generated: ",
      t,
      ", which is not valid SchemaOrg format"
    );
    return;
  }
  return t;
}, dn = (e) => {
  const t = v(() => {
    if (!(typeof e > "u"))
      return kt(e);
  }, [e]);
  we(t, D.FAQPage);
}, pn = (e) => {
  const t = Pe(e);
  we(
    t,
    ft(t) ? D.Product : D.ProductList
  );
}, Mt = n.object({
  a: n.string(),
  q: n.string()
}), Oe = n.object({
  qa: n.array(Mt)
});
function ln(e) {
  return Oe.safeParse(e).success;
}
function gn(e) {
  const t = Oe.safeParse(e);
  if (t.success)
    return t.data;
}
const jt = c.object({
  sku: c.string(),
  name: c.string(),
  uri: c.string(),
  excerpt: c.string().optional(),
  brand: c.string().optional(),
  countryOrigin: c.string().optional().nullable(),
  price: c.object({
    priceAsNumber: c.number()
  }),
  mediaUrls: c.array(c.string()),
  frontendItems: c.array(
    c.object({
      sku: c.string(),
      name: c.string(),
      ean: c.string().optional(),
      quantity: c.number().optional()
    })
  )
});
function At(e) {
  const t = jt.safeParse(e);
  return t.success || console.warn(
    "Type validation of StructuredDataFormattableCentraProduct failed: ",
    t.error
  ), t.success;
}
function mn(e) {
  if (!(typeof e > "u") && At(e))
    return {
      sku: e.sku,
      name: e.name,
      description: e.excerpt,
      brandName: e.brand,
      priceAsNumber: e.price.priceAsNumber,
      imageUrls: e.mediaUrls,
      countryOfOrigin: e.countryOrigin,
      urlSlug: e.uri,
      variants: e.frontendItems.map((t) => ({
        sku: t.sku,
        size: t.name,
        ean: t.ean,
        imageUrls: e.mediaUrls,
        quantity: t.quantity
      }))
    };
}
function yn(e) {
  switch (e.dataModel) {
    case "simple":
      return It(e);
    case "with_variants":
      return Ft(e);
    case "bundle":
      return Ct(e);
    default:
      throw new Error("Unsupported product type" + e.dataModel);
  }
}
function It(e) {
  const t = Z(e);
  return {
    sku: e.sku,
    name: e.base.content.name,
    description: e.base.content.description,
    brandName: e.base.content.brand,
    priceAsNumber: e.priceInfo.price.number,
    imageUrls: t,
    urlSlug: e.base.slug,
    variants: [
      {
        sku: e.sku,
        size: "One size",
        ean: e.ean,
        imageUrls: t,
        quantity: e.inventory.quantity
      }
    ]
  };
}
function Ft(e) {
  var i;
  const t = Z(e);
  return {
    sku: e.base.productId,
    name: e.base.content.name,
    description: e.base.content.description,
    brandName: e.base.content.brand,
    priceAsNumber: (i = e.variants[0]) == null ? void 0 : i.priceInfo.price.number,
    imageUrls: t,
    urlSlug: e.base.slug,
    variants: e.variants.map((s) => ({
      sku: s.sku,
      size: s.label,
      ean: s.ean,
      imageUrls: t,
      quantity: s.inventory.quantity
    }))
  };
}
function Ct(e) {
  const t = Z(e);
  return {
    sku: e.bundlePurchaseInfo.sku,
    name: e.base.content.name,
    description: e.base.content.description,
    brandName: e.base.content.brand,
    priceAsNumber: e.bundlePurchaseInfo.priceInfo.price.number,
    imageUrls: t,
    urlSlug: e.base.slug,
    variants: [
      {
        sku: e.bundlePurchaseInfo.sku,
        size: "Bundle",
        imageUrls: t,
        quantity: e.bundlePurchaseInfo.inventory.quantity
      }
    ]
  };
}
function Z(e) {
  return e.base.content.media.filter(Fe).map((t) => t.src);
}
export {
  Ne as GearsStructuredDataContextProvider,
  fn as GearsStructuredDataHeadTag,
  Be as StructuredDataBreadcrumbs,
  St as StructuredDataProducts,
  $t as StructuredDataProvider,
  D as StructuredDataScriptName,
  vt as StructuredDataShippingDetails,
  wt as StructuredDataShippingRateSettings,
  le as aggregateOfferSchema,
  _ as aggregateRatingSchema,
  xe as breadcrumbListSchema,
  fe as dayOfWeekSchema,
  mn as defaultMapCentraProductToStructuredDataProduct,
  W as definedRegionSchema,
  Tt as faqPageSchema,
  yn as greaseProductToUnformattedStructuredDataProduct,
  _t as isAggregateOffer,
  Kt as isAggregateRating,
  Le as isBreadcrumbList,
  Wt as isDayOfWeek,
  _e as isDefinedRegion,
  Dt as isFAQPage,
  qt as isItemAvailability,
  tn as isMerchantReturnPolicy,
  gt as isMerchantReturnPolicySettings,
  rn as isMerchantReturnPolicySettingsEntry,
  ce as isMonetaryAmount,
  Ht as isOffer,
  et as isOfferShippingDetails,
  M as isOfferShippingDetailsSettings,
  an as isOfferShippingDetailsSettingsEntry,
  ft as isProduct,
  lt as isProductList,
  Gt as isProductModel,
  Bt as isQuantitativeValue,
  Xt as isRating,
  Zt as isReview,
  Ye as isShippingDeliveryTime,
  on as isShippingDeliveryTimeSetting,
  Rt as isShippingRateSettings,
  ln as isStoryblokFAQPage,
  B as itemAvailabilitySchema,
  ge as merchantReturnPolicySchema,
  ye as merchantReturnPolicySettingsEntrySchema,
  he as merchantReturnPolicySettingsSchema,
  L as monetaryAmountSchema,
  H as offerSchema,
  pe as offerShippingDetailsSchema,
  Se as offerShippingDetailsSettingsEntrySchema,
  ve as offerShippingDetailsSettingsSchema,
  me as productListSchema,
  G as productModelSchema,
  X as productSchema,
  U as quantitativeValueSchema,
  K as ratingSchema,
  J as reviewSchema,
  de as shippingDeliveryTimeSchema,
  be as shippingDeliveryTimeSettingSchema,
  Re as shippingRateSettingsSchema,
  se as storyblokTimeRangeFieldTypeSchema,
  w as structuredDataContext,
  Jt as toAggregateRatingOrUndefined,
  sn as toMerchantReturnPolicySettingsOrUndefined,
  un as toOfferShippingDetailsSettingsOrUndefined,
  nn as toProductListOrUndefined,
  it as toProductModelOrUndefined,
  dt as toProductOrUndefined,
  re as toQuantitativeValueOrUndefined,
  Yt as toRatingOrUndefined,
  en as toReviewOrUndefined,
  cn as toShippingRateSettingsOrUndefined,
  gn as toStoryblokFAQPageOrUndefined,
  Ee as useAddGearsStructuredDataHeadTagScript,
  ze as useBreadCrumbs,
  Ve as useGearsStructuredDataHeadTagScripts,
  dn as useInjectFAQPage,
  pn as useInjectStructuredDataProducts,
  qe as useMerchantReturnPolicySettings,
  Qe as usePdpProduct,
  Qt as useRemoveGearsStructuredDataHeadTagScript,
  $e as useShippingDetailsSettings,
  R as useStructuredDataContext,
  we as useStructuredDataInjector,
  zt as useStructuredDataMappers,
  mt as useStructuredDataMerchantReturnPolicy,
  Y as useStructuredDataOfferShippingDetails,
  Pe as useStructuredDataProduct,
  bt as useStructuredDataShippingDeliveryTime,
  ht as useStructuredDataShippingDestination,
  yt as useStructuredDataShippingRate
};
